module.exports = __webpack_public_path__ + "img/bannow_small.62f8da1c.png";